import { IAPIResponseError, IError } from '@checkout/errors';
import { ISelection } from '@checkout/items';
import { ISelectionStatePayload } from '@checkout/payloadTypes';
import { ILocation, ILoggedIn, RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic, ofType } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { concat as concat$ } from 'rxjs/observable/concat';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { catchError, switchMap } from 'rxjs/operators';
import { checkoutApi } from 'ys-analytics';
import { RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import {
  // fetchSelectionError,
  fetchSelectionSuccess,
  preselectInitialValues,
  responseError,
  setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { getQueryParametersAsObject as getUrlVars } from './../utils/apiUtils';
import convertMessages from './../utils/convertErrors';
import { logger } from './../utils/logger';

// const isShipwalletAvailable = (shipwallet: any) => (shipwallet !== undefined) && !shipwallet.error;
const { eeCheckout, eeCheckoutSteps, fbInitiateCheckout } = checkoutApi;

function selectionAnalitycs(location: ILocation, loggedIn: ILoggedIn | null, selection: ISelection) {
  const { items, currency, paymentMethod, shippingMethod, shipwallet } = selection;

  if (items.length > 0) {
    try {
      eeCheckout(items, currency);
    } catch (err) {
      // tslint:disable-next-line:no-console
      console.error('Enhanced Ecommerce error: ', err);
    }
    try {
      fbInitiateCheckout(items, currency);
    } catch (err) {
      // tslint:disable-next-line:no-console
      console.error('Enhanced Ecommerce error: ', err);
    }
    try {
      eeCheckoutSteps.countryLoad(location.country, currency);
    } catch (err) {
      // tslint:disable-next-line:no-console
      console.error('Enhanced Ecommerce error: ', err);
    }
    try {
      eeCheckoutSteps.paymentLoad(paymentMethod, currency);
    } catch (err) {
      // tslint:disable-next-line:no-console
      console.error('Enhanced Ecommerce error: ', err);
    }
    if (shipwallet === undefined) {
      try {
        eeCheckoutSteps.shippingLoad(shippingMethod, currency);
      } catch (err) {
        // tslint:disable-next-line:no-console
        console.error('Enhanced Ecommerce error: ', err);
      }
    }
    if (loggedIn) {
      try {
        eeCheckoutSteps.loggedUserLoad(currency);
      } catch (err) {
        // tslint:disable-next-line:no-console
        console.error('Enhanced Ecommerce error: ', err);
      }
    }
  }
}

export const fetchSelectionEpic: Epic<RootAction, RootAction, RootState> = (action$, state$): Observable<RootAction> =>
  action$.pipe(
    ofType(ActionTypes.FETCH_SELECTION_REQUEST),
    switchMap((action) => {
      const selection = getUrlVars(location.search).selection;

      if (selection) {
        return fromPromise$(rest.httpPut(`/selection/${selection}`));
      } else {
        return fromPromise$(rest.httpGet('/selection'));
      }
    }),
    switchMap((payload: AxiosResponse<ISelectionStatePayload>) => {
      const { location, loggedIn, selection } = payload.data;

      selectionAnalitycs(location, loggedIn, selection);

      if (!state$.value.checkout.token) {
        return concat$(
          of$(fetchSelectionSuccess(payload.data)),
          of$(preselectInitialValues(payload.data))
        );
      }
      return of$(fetchSelectionSuccess(payload.data));
    }),
    catchError((error: IError) => {
      logger(error);
      if (error.response && error.response.data) {
        const convertedMessages = convertMessages(error.response.data, state$.value.checkout.intlData);
        const responseApiErrorPayload: IAPIResponseError = {
          errors: convertedMessages,
          selection: error.response.data.selection,
          unavailable: error.response.data.unavailable,
        };
        return of$(responseError(responseApiErrorPayload));
      }
      return of$(setErrors(error));
    })
  );
